<template>
  <div class="picker cursor-pointer" @click="toggle" ref="picker">
    <div ref="knob"></div>
    <div class="header">
      <div
        v-show="overline != null"
        class="overline text-uppercase text-grey-7"
      >
        {{ overline }}
      </div>
      <div v-show="title" class="title text-capitalize text-dark">
        {{ title }}
      </div>
      <div v-show="caption" class="caption">{{ caption }}</div>
    </div>
    <DFullScreenCarouselPickerScroller
      @tileClick="tileClick"
      :behavior="behavior"
      :images="images"
      :height="scrollerHeight"
      :virtualtour="virtualtour"
    />
  </div>
</template>

<script>
import anime from "animejs";
import DFullScreenCarouselPickerScroller from "./DFullScreenCarouselPickerScroller.vue";
import getImgUrl from "../../mixins/get-img-url";
export default {
  name: "DFullScreenCarouselPicker",
  components: { DFullScreenCarouselPickerScroller },
  props: {
    behavior: {
      type: String,
      default: "agent",
    },
    height: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  mixins: [getImgUrl],
  computed: {
    controlHeight: {
      get() {
        return parseInt(this.height.replace("px", ""));
      },
    },
    scrollerHeight: {
      get() {
        return this.controlHeight - 195;
      },
    },
    title: {
      get() {
        return this.componentData.data?.title
          ? this.componentData.data.title
          : null;
      },
    },
    virtualtour: {
      get() {
        return this.componentData.data?.virtualtour
          ? this.componentData.data.virtualtour
          : null;
      },
    },
    overline: {
      get() {
        return this.componentData.data?.overline
          ? this.componentData.data.overline
          : null;
      },
    },
    caption: {
      get() {
        return this.componentData.data?.caption
          ? this.componentData.data.caption
          : null;
      },
    },
    images: {
      get() {
        return this.componentData.data.images.map((item, index) => {
          const src = this.getImgUrl({
            ...item,
            url: `${this.componentData.baseUrl}${item.src}`,
            poster: `${this.componentData.baseUrl}${item.poster}`,
          });

          return {
            src,
            overline: item?.overline ?? null,
            title: item?.title ? item.title : null,
            caption: item?.caption ?? null,
            type:
              /\.webp|\.(j|pn)(p|pe)g|\.gif/gi.test(src) &&
              /cenora\.io/gi.test(src)
                ? "image"
                : item.type,
            index: index,
            section: item.section,
          };
        });
      },
    },
  },
  mounted() {
    this.renderPicker();
  },
  methods: {
    renderPicker() {
      Object.assign(this.$refs.picker.style, {
        position: "absolute",
        top: `${this.height}`,
        left: 0,
        width: "100%",
        height: `calc(${this.height} * 0.75)`,
        color: "black",
        background: "white",
        borderRadius: "12px 12px 0 0",
      });
      this.renderKnob();
    },
    renderKnob() {
      const pickerRect = this.$refs.picker.getBoundingClientRect();
      const knob = this.$refs.knob;
      const knobWidth = 40;
      Object.assign(knob.style, {
        position: "absolute",
        width: `${knobWidth}px`,
        height: "4px",
        borderRadius: "3px",
        backgroundColor: "rgba(0,0,0,.58)",
        opacity: ".5",
        top: "12px",
        left: `${(pickerRect.width - knobWidth) / 2}px`,
      });
    },
    toggle() {
      this.opened = !this.opened;
      this.move();
    },
    close(emit = true) {
      if (this.opened) {
        this.opened = false;
        this.move(emit);
      }
    },
    open(emit = true) {
      if (!this.opened) {
        (this.opened = true), this.move(emit);
      }
    },
    move(emit = true) {
      anime({
        targets: this.$refs.picker,
        translateY: this.opened ? -this.controlHeight * 0.75 : 0,
        duration: 200,
        easing: "linear",
        changeComplete: () => {
          // emit show
          if (emit) {
            if (this.opened) {
              this.$emit("show");
            } else {
              this.$emit("hide");
            }
          }
        },
      });
    },
    tileClick(index) {
      this.$emit("tileClick", index);
      this.toggle();
    },
  },
};
</script>

<style scoped>
.picker {
  box-shadow: 0px -5px 7px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.02px;
}
.header {
  text-transform: uppercase;
  margin-top: 12px;
  padding: 16px 16px 8px;
  color: #373737;
}
.overline {
  font-weight: 800;
  font-size: 9px;
  line-height: 16px;
  opacity: 0.8;
}
.title {
  line-height: 18px;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.02px;
}
.caption {
  line-height: 18px;
  font-size: 11px;
  font-weight: 400;
  color: #757575;
}
</style>
